import { groupList } from '@/mocks/homeData';

export default function GroupExchange() {
  return (
    <section id="groups" className="w-full bg-background-100">
      <div className="w-full px-4 py-16 md:px-10 md:py-24">
        <div className="flex flex-col gap-5 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.32em] text-primary-600">GROUP EXCHANGE</p>
            <h2 className="mt-5 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              群组互换
            </h2>
          </div>
          <p className="max-w-md text-sm leading-loose text-foreground-600">
            想找人对接资源，从这些群组开始。每个群都有明确的主题，进群前请先看清说明，互换以私信为准。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {groupList.map((group) => (
            <article
              key={group.name}
              className="group flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-secondary-300"
            >
              <div>
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-heading text-lg text-foreground-950 transition-colors group-hover:text-secondary-800">
                    {group.name}
                  </h3>
                  <span
                    className={`flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] ${
                      group.status === '活跃'
                        ? 'bg-secondary-100 text-secondary-900'
                        : 'bg-accent-100 text-accent-900'
                    }`}
                  >
                    <span
                      className={`h-1.5 w-1.5 rounded-full ${
                        group.status === '活跃' ? 'bg-secondary-500' : 'bg-accent-500'
                      }`}
                    ></span>
                    {group.status}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{group.desc}</p>
              </div>
              <div className="mt-6 flex items-center justify-between border-t border-background-200 pt-4">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="rounded-full bg-background-100 px-2.5 py-1 text-foreground-700">
                    {group.tag}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-group-line"></i>
                    {group.members}
                  </span>
                </div>
                <button
                  type="button"
                  className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-xs text-background-50 transition-colors hover:bg-secondary-700"
                >
                  <i className="ri-message-3-line"></i>
                  私信互换
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}